import { useAssetVizInternal } from '@asset-viz/AssetVizInternalProvider'
import { FC, useMemo } from 'react'
import styled from 'styled-components'
import { GeckoComponentPolygon, GeckoLinerRegion } from 'types'

import { PolygonFeatureLabel3D } from './procedural/PolygonFeatureLabel3D'
import {
  SurfaceLineFeature3D,
  SurfaceLineSelectionType,
} from './procedural/SurfaceLineFeature3D'
import {
  SurfaceMeshFeature3D,
  SurfaceMeshSelectionType,
} from './procedural/SurfaceMeshFeature3D'

const StyledPolygonFeatureLabel3D = styled(PolygonFeatureLabel3D)<{
  color: string
}>`
  color: ${(props) => props.color};
  font-weight: 900;
  overflow: visible;
`

export const LinerRegionFeature3D: FC<{ model: GeckoLinerRegion }> = ({
  model,
}) => {
  const { showPlateFeatureDebugColors, corrosionRegionColorString } =
    useAssetVizInternal()

  const boundingPath = useMemo(() => {
    return GeckoComponentPolygon.CreateFromRect(model.geometry)
  }, [model.geometry])

  return (
    <group key={model.id}>
      <SurfaceLineFeature3D
        path={boundingPath}
        featureModel={model}
        lineSelectionType={SurfaceLineSelectionType.SelectableFeatureLine}
      />
      <SurfaceMeshFeature3D
        path={boundingPath}
        featureModel={model}
        selectionType={SurfaceMeshSelectionType.AssetModelEditorSelectable}
        showDebugColors={showPlateFeatureDebugColors}
        userDataName={'liner'}
      />
      <StyledPolygonFeatureLabel3D
        color={corrosionRegionColorString}
        feature={model}
        polygonPath={boundingPath}
      />
    </group>
  )
}
